import React from "react";
import { Quote, ArrowRight, ArrowLeft } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  quote: "Inara Technologies helped us migrate to the cloud seamlessly and improved our operational efficiency significantly. The transition was smoother than we ever anticipated.",
  author: "Jane N.",
  role: "CEO, TechStart Kenya",
  metric: "99.9% Uptime Achieved",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/techstart_logo.png"
}, {
  id: 2,
  quote: "Their AI solutions enabled us to automate our processes and reduce costs by 30%. Highly recommended for any enterprise looking to scale efficiently.",
  author: "Michael K.",
  role: "Head of Operations, GreenEnergy Ltd.",
  metric: "30% Cost Reduction",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/greenenergy_logo.png"
}, {
  id: 3,
  quote: "The digital transformation roadmap provided by Inara was a game-changer. We've seen a massive uptake in user engagement across all our platforms.",
  author: "Sarah O.",
  role: "CTO, FinServe Africa",
  metric: "2x User Engagement",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/finserve_logo.png"
}, {
  id: 4,
  quote: "Reliable support and cutting-edge cloud infrastructure have allowed us to expand into new regional markets with confidence and speed.",
  author: "David M.",
  role: "Director, AgriTech Solutions",
  metric: "3 New Markets Entered",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/agritech_logo.png"
}];
export default function SuccessStories() {
  return <section id="success-stories" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-accent/5 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-white/70">
            Success Stories
          </h2>
          <p className="text-lg text-muted-foreground">
            See how leading enterprises in Kenya and East Africa are transforming
            their operations with our AI and Cloud solutions.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((item, i) => <CarouselItem key={item.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <div className="h-full">
                  <Card className="h-full bg-card/30 backdrop-blur-md border-white/10 hover:border-primary/30 transition-all duration-300 group overflow-hidden relative">
                    {}
                    <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                    <CardContent className="p-8 flex flex-col h-full relative z-10">
                      {}
                      <div className="mb-6">
                        <Quote className="size-10 text-primary/40 fill-primary/10" />
                      </div>

                      {}
                      <blockquote className="flex-grow mb-8">
                        <p className="text-xl italic font-sans text-foreground/90 leading-relaxed">
                          "{item.quote}"
                        </p>
                      </blockquote>

                      {}
                      <div className="mt-auto pt-6 border-t border-white/5 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 items-center">
                        {}
                        <div className="row-span-2 flex items-center justify-center bg-white/5 rounded-lg p-2 size-12">
                          <img src={item.logo} alt={`${item.author} company logo`} className="w-full h-full object-contain opacity-80" />
                        </div>

                        {}
                        <div className="flex flex-col">
                          <span className="font-semibold text-foreground text-sm">
                            {item.author}
                          </span>
                          <span className="text-xs text-muted-foreground truncate">
                            {item.role}
                          </span>
                        </div>

                        {}
                        <div className="col-span-2 mt-3">
                          <Badge variant="outline" className="bg-accent/10 border-accent/20 text-accent-foreground px-3 py-1 text-xs font-medium tracking-wide uppercase w-full justify-center">
                            {item.metric}
                          </Badge>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-center gap-4 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 border-primary/30 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_20px_rgba(6,182,212,0.5)] transition-all duration-300 rounded-full" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 border-primary/30 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_20px_rgba(6,182,212,0.5)] transition-all duration-300 rounded-full" />
          </div>
        </Carousel>
      </div>
    </section>;
}